import React from "react";
import cx from "classnames";

interface ButtonProps extends React.HTMLProps<HTMLButtonElement> {
  type?: "submit" | "reset" | "button";
}

const Button: React.FC<ButtonProps> = ({
  className,
  type,
  children,
  disabled,
  ...props
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      {...props}
      className={cx(
        "px-20 py-5 font-bold text-white rounded-full bg-primary",
        className,
          {
           'bg-gray-400': disabled
          }
      )}
    >
      {children}
    </button>
  );
};

Button.defaultProps = {
  type: "button",
};

export default React.memo(Button);
